// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3cTDk","Div":"CustomFadeBox_Div__u30Mv","LargeDiv":"CustomFadeBox_LargeDiv__IYZbZ"};